<template>
    <span v-html="formattedText"></span>
</template>

<script>
export default {
    name: 'multi-line-label',
    props: {
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        formattedText() {
            return this.text.replace(/ /g, '<br>');
        }
    }
};
</script>